import React from "react";
import { NumberInput } from "./NumberInput";
import { StringInput } from "./StringInput";
import { CheckboxInput } from "./CheckboxInput";
import { ColorInput } from "./ColorInput";
import { SelectInput } from "./SelectInput";
import { VectorInput } from "./VectorInput";
import { ImageInput } from "./ImageInput";
import { Model3dInput } from "./Model3dInput";
import { NodeRefInput } from "./NodeRefInput";
import { PropertiesTable } from "../components/PropertiesTable";
import { NodeListInput } from "./NodeListInput";
import { Infotext } from "./Infotext";

export const GenericInput = ({ node, property, setSelected, nodeIndex, isTopNode }) => {
  if (property.inputComponent != null) {
    const Input = property.inputComponent;
    return (
      <Input
        node={node}
        property={property}
        setSelected={setSelected}
        nodeIndex={nodeIndex}
        isTopNode={isTopNode}
      />
    );
  }
  const { type } = property;
  if (property.editable === false && !["Model3d", "Image", "Texture"].includes(type)) {
    return <Infotext property={property} />;
  }
  if (property.selectOptions != null) {
    return <SelectInput property={property} />;
  }
  switch (type) {
    case "Number":
      return <NumberInput property={property} />;
    case "Boolean":
      return <CheckboxInput property={property} />;
    case "Map":
    case "List":
    case "String":
      return <StringInput property={property} />;
    case "Vector2":
    case "Vector3":
    case "Vector4":
    case "Euler":
      return <VectorInput property={property} />;
    case "Color":
      return <ColorInput property={property} />;
    case "Image":
    case "Texture":
      return <ImageInput property={property} />;
    case "Model3d":
      return (
        <Model3dInput
          property={property}
          setSelected={setSelected}
          nodeIndex={nodeIndex}
          isTopNode={isTopNode}
        />
      );
    case "Json":
      return null;
    case "NodeRef":
      return (
        <NodeRefInput
          node={node}
          property={property}
          setSelected={setSelected}
          nodeIndex={nodeIndex}
          isTopNode={isTopNode}
        />
      );
    case "SubNode":
      return (
        <PropertiesTable
          node={property.get()}
          setSelected={setSelected}
          seamless={property.seamless}
          nodeIndex={nodeIndex}
          isTopNode={isTopNode}
        />
      );
    case "NodeList":
      return (
        <NodeListInput
          node={node}
          property={property}
          setSelected={setSelected}
          nodeIndex={nodeIndex}
          isTopNode={isTopNode}
        />
      );
    case "Any":
      return <div>{property.get()}</div>;
    // case 'ModelMaterialRelation':
    //     return (<ModelMaterialRelationInput property={property}/>);
    default:
      return <div>{type} NOT IMPLEMENTED YET</div>;
  }
};
